/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  TaskDataImage,
  TaskDataImagePng,
  TaskDataImageJpeg,
  TaskDatumType
} from '../../../../../../../models/task.model';
import { Logger, LogService } from '@epg/angular-base-lib';

@Component({
  selector: 'app-image-item',
  templateUrl: './image-item.component.html',
  styleUrls: ['./image-item.component.scss'],
  standalone: false
})
export class ImageItemComponent implements OnInit {
  @Input() imageItem: TaskDataImage = new TaskDataImagePng('');
  imagePath: SafeResourceUrl = '';
  TaskDatumType = TaskDatumType;
  private log: Logger;
  constructor(
    private _sanitizer: DomSanitizer,
    private logService: LogService
  ) {
    this.log = logService.getLogger(this);
  }

  ngOnInit(): void {
    if (this.imageItem.type === TaskDatumType.IMAGE_URL) {
      return;
    }

    let mimeType;
    switch (this.imageItem.type) {
      case TaskDatumType.IMAGE_PNG:
        mimeType = 'image/png';
        break;
      case TaskDatumType.IMAGE_JPEG:
      default:
        mimeType = 'image/jpeg';
        break;
    }

    this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl(
      'data:' + mimeType + ';base64,' + this.imageItem.value
    );
  }
}
